import { observer } from "owa-mobx-react";
import { isGlobalFeatureEnabled } from "owa-feature-flags/lib/utils/isFeatureEnabled";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";
import React from "react";
import { LazyStatusBarReminders, LazyStatusBarZoom } from "../lazyStatusBarItems";
import { statusBar } from "./StatusBar.scss";

type StatusBarProps = {
    targetRef?: React.Ref<HTMLDivElement>;
};

const StatusBar: React.FunctionComponent<StatusBarProps> = observer(function StatusBar({ targetRef, }) {
    // Show the status bar for everyone on the general flight, or only with Win32 styling on its separate flight.
    if (!isGlobalFeatureEnabled("mon-status-bar") &&
        (!isWin32StylingEnabled() || !isGlobalFeatureEnabled("mon-win32-styling-status-bar"))) {
        return null;
    }
    
    return (<div className={statusBar} ref={targetRef}>
            <LazyStatusBarReminders />
            <LazyStatusBarZoom />
        </div>);
}, "StatusBar");

export default StatusBar;
